module.exports = __webpack_public_path__ + "static/media/last-slide.795ff883.svg";